export const wingDetails = [
  {
    wing: "Innovation Wing",
    tagline: "Where ideas become installed, measured, and scaled.",
    description:
      "The Innovation Wing is TIE's factory-facing engine. It runs the full innovation lifecycle - from ideation circles on the shop floor to practically tested models that can be scaled across factory groups.",
    icon: "ri-flashlight-line",
    color: "bg-tie-teal/10 border-tie-teal/20",
    iconBg: "bg-tie-teal",
    items: [
      {
        code: "PIIC",
        name: "Partnership for Implementation of Innovation Circles",
        tagline: "4-month factory-embedded operating system",
        detail:
          "Each PIIC deployment installs 2–4 Innovation Circles inside a factory, each with 6 cross-functional members. Over 16 weeks, the circles identify bottlenecks, prototype solutions, and produce evidence packs with before-and-after metrics. PIIC is TIE's foundational programme - the entry point for any factory serious about systematic innovation.",
        outcomes: [
          "2–4 active Innovation Circles per factory",
          "Evidence pack with quantitative metrics",
          "Installed innovation governance structure",
        ],
      },
      {
        code: "PTIM",
        name: "Practically Tested Innovation Model",
        tagline: "Test before you scale",
        detail:
          "PTIM bridges the gap between a promising PIIC outcome and a factory-wide rollout. It creates a structured, time-bound test environment where an innovation is validated under real production conditions before capital and labour are committed at scale.",
        outcomes: [
          "Validated ROI and risk profile",
          "Standard operating procedure (SOP)",
          "Go / no-go decision framework",
        ],
      },
      {
        code: "Training",
        name: "FSD / PSD / Innovation Black Belt",
        tagline: "Three-tier professional certification",
        detail:
          "TIE's training programme certifies innovation practitioners at three levels: Factory Skills Development (FSD), Professional Skills Development (PSD), and Innovation Black Belt - a combined 256+ hours of structured learning, factory projects, and peer assessment.",
        outcomes: [
          "Certified innovation facilitators",
          "Trained circle leaders and coaches",
          "Internal T&A innovation academy",
        ],
      },
      {
        code: "Experts",
        name: "TIE Experts' Platform & Turn-key Consultancy",
        tagline: "150+ seasoned specialists on demand",
        detail:
          "A curated marketplace of 150+ textile experts covering lean manufacturing, dyeing, compliance, digital systems, and sustainability. Factories can engage experts for turn-key projects, diagnostic audits, or ongoing advisory retainer.",
        outcomes: [
          "Matched expert within 48 hours",
          "Defined scope and deliverables",
          "Knowledge transfer to internal team",
        ],
      },
    ],
  },
  {
    wing: "Research Wing",
    tagline: "Generating the evidence base for sector-level decisions.",
    description:
      "The Research Wing produces peer-reviewed, factory-validated research that guides policy, investment, and operational priorities across Bangladesh's textile ecosystem.",
    icon: "ri-microscope-line",
    color: "bg-tie-navy/5 border-tie-navy/10",
    iconBg: "bg-tie-navy",
    items: [
      {
        code: "PIARC",
        name: "Partnership for Implementation of Applied Research Circles",
        tagline: "Research that solves real factory problems",
        detail:
          "PIARC brings together academics, factory engineers, and industry practitioners in applied research circles. Each circle focuses on a live production problem - water consumption in dyeing, defect clustering in knitting, line balancing in sewing - and produces an implementable research output within 6 months.",
        outcomes: [
          "Peer-validated research findings",
          "Factory-ready implementation guide",
          "Published case study for sector learning",
        ],
      },
      {
        code: "IJTAI",
        name: "International Journal of Textile & Apparel Innovation",
        tagline: "Bi-annual peer-reviewed publication",
        detail:
          "IJTAI is the first peer-reviewed journal dedicated to textile and apparel innovation in South Asia. Published bi-annually, it features validated research, factory case studies, technology assessments, and policy commentary from Bangladesh and global contributors.",
        outcomes: [
          "Indexed research output for authors",
          "Sector benchmark database",
          "Global visibility for Bangladesh T&A research",
        ],
      },
      {
        code: "AIRCon",
        name: "Annual International Research Conference",
        tagline: "Where research meets practice",
        detail:
          "Held every January, AIRCon convenes researchers, factory leaders, brand sustainability heads, and policymakers for two days of paper presentations, panel debates, and factory field visits. It sets the annual research agenda for the sector.",
        outcomes: [
          "Annual research priority framework",
          "Cross-border collaboration network",
          "Published proceedings volume",
        ],
      },
    ],
  },
  {
    wing: "Readiness & Recognition",
    tagline: "Prove readiness. Earn recognition. Unlock markets.",
    description:
      "This wing ensures that innovation is not only implemented but also verified, certified, and communicated to buyers, investors, and the public.",
    icon: "ri-award-line",
    color: "bg-amber-50 border-amber-100",
    iconBg: "bg-amber-500",
    items: [
      {
        code: "InnoReadiness",
        name: "TIE Innovation Readiness Certification",
        tagline: "Verify your innovation capability",
        detail:
          "A third-party assessment framework that evaluates a factory's innovation infrastructure, process maturity, evidence documentation, and scale-up track record. Three certification tiers - Bronze, Silver, and Gold - each with defined criteria and audit protocols.",
        outcomes: [
          "Independent readiness scorecard",
          "Marketable certification badge",
          "Buyer due diligence support",
        ],
      },
      {
        code: "Awards",
        name: "TIE Innovation Awards",
        tagline: "Celebrating measurable excellence",
        detail:
          "Annual awards programme recognizing factories, individuals, and institutions that demonstrate outstanding innovation outcomes. Categories include Best Innovation Circle, Breakthrough Technology Adoption, Sustainability Champion, and Research Impact.",
        outcomes: [
          "Sector-wide recognition platform",
          "Media coverage and buyer visibility",
          "Talent attraction and retention signal",
        ],
      },
    ],
  },
  {
    wing: "Expo Wing",
    tagline: "The marketplace where innovation meets the market.",
    description:
      "The Expo Wing creates the commercial and collaborative marketplace for textile innovation - matching solution providers with factories, and showcasing breakthrough technologies to brands and investors.",
    icon: "ri-store-2-line",
    color: "bg-violet-50 border-violet-100",
    iconBg: "bg-violet-500",
    items: [
      {
        code: "TIExpo",
        name: "Textile Innovation Expo",
        tagline: "Annual B2B marketplace for textile innovation",
        detail:
          "Bangladesh's premier textile innovation exhibition held at the International Convention City, Bashundhara. The Expo brings together 200+ exhibitors, 5,000+ factory delegates, and international brand sustainability teams under one roof for three days of demos, matchmaking, and deal-making.",
        outcomes: [
          "Direct technology procurement deals",
          "Factory-solution provider matchmaking",
          "Investor and brand visibility",
        ],
      },
      {
        code: "Concurrent",
        name: "Concurrent Expos",
        tagline: "Specialized parallel events",
        detail:
          "Running alongside the main Expo: the Denim Innovation Expo, Circular Fashion Expo, and Smart Manufacturing Expo - each dedicated to a vertical within Bangladesh's textile sector. Attendees can move between expos based on their strategic priorities.",
        outcomes: [
          "Vertical-specific audience targeting",
          "Niche technology showcase",
          "Specialized B2B matchmaking",
        ],
      },
    ],
  },
];

export const programmeStats = [
  { value: "250+", label: "Projects Deployed", sub: "across 80+ factories" },
  { value: "4", label: "Programme Wings", sub: "covering full innovation lifecycle" },
  { value: "12", label: "Research Publications", sub: "in IJTAI and AIRCon" },
  { value: "150+", label: "Expert Associates", sub: "across 30+ specializations" },
];